const isPermissiveNumeric = (s) => /^-?(?:\d+(\.\d*)?|\.\d+)?$/.test(s);
const clamp = (n, min, max) => Math.min(max, Math.max(min, n));
const formatDisplay = (raw) => {
    if (raw === undefined || raw === null || raw === "")
        return "";
    if (raw === "-")
        return "-";
    let num;
    if (typeof raw === "number") {
        num = raw;
    }
    else {
        const cleaned = raw.replace(/,/g, "");
        if (cleaned === "-")
            return "-";
        num = Number(cleaned);
    }
    if (Number.isNaN(num))
        return "";
    const sign = num < 0 ? "-" : "";
    const abs = Math.abs(num);
    return sign + abs.toLocaleString("en-US");
};
const roundHalfToNearest = (n) => {
    const fracAbs = Math.abs(n - Math.trunc(n));
    const towardZero = n >= 0 ? Math.floor(n) : Math.ceil(n);
    const awayFromZero = n >= 0 ? Math.ceil(n) : Math.floor(n);
    return fracAbs < 0.5 ? towardZero : awayFromZero;
};
const parseOrNull = (s) => {
    if (s.trim() === "" || s === "-" || s === "+")
        return null;
    const num = Number(s);
    return Number.isNaN(num) ? null : num;
};

export { clamp, formatDisplay, isPermissiveNumeric, parseOrNull, roundHalfToNearest };
